import { Component, computed, inject, LOCALE_ID, OnInit, signal } from '@angular/core';
import { CompaniesService } from '../../../../services/companies/companies.service';
import { ActivatedRoute, Router } from '@angular/router';
import { OneCompanyResponseData } from '../../../../pages/admin-dashboard/admin-companies/admin-companies.model';
import { finalize } from 'rxjs';
import { CompaniesFileMgt } from '../../../../services/companies/filemgt.companies.service';
import { DateTimePipe } from '../../../../shared/utils/date-time.pipe';

@Component({
  selector: 'app-view-company-details',
  imports: [DateTimePipe],
  templateUrl: './view-company-details.html',
  styleUrl: './view-company-details.scss',
})
export class ViewCompanyDetails implements OnInit {
  private locale = inject(LOCALE_ID);
  isArabic = computed(() => this.locale.startsWith('ar'));
  private companyServie = inject(CompaniesService);
  private filemgtService = inject(CompaniesFileMgt);
  private route = inject(ActivatedRoute);
  companyId = this.route.snapshot.paramMap.get('id');

  loading = signal<boolean>(false);
  errorLoadingCompany = signal<boolean>(false);
  imagePreviewUrl = signal<string>('');
  companyDetails = signal<OneCompanyResponseData>({
    createdBy: {
      fullName: '',
      id: 0,
    },
    createdOn: '',
    descriptionAr: '',
    descriptionEn: '',
    id: 0,
    isActive: false,
    lastModifiedBy: '',
    lastModifiedOn: '',
    profileImageFid: '',
    titleAr: '',
    titleEn: '',
  });
  ngOnInit(): void {
    console.log('company id: ', this.companyId);
    this.loading.set(true);
    this.companyServie
      .getOneMFGCompany(+this.companyId!)
      .pipe(
        finalize(() => {
          this.loading.set(false);
        }),
      )
      .subscribe({
        next: (res: OneCompanyResponseData) => {
          console.log('res: ', res);
          this.companyDetails.set(res);
          this.filemgtService.getImage(res.profileImageFid).subscribe({
            next: (blob: Blob) => {
              const url = window.URL.createObjectURL(blob);
              this.imagePreviewUrl.set(url);
            },
            error: () => {},
          });
        },
        error: () => {
          this.errorLoadingCompany.set(true);
        },
      });
  }
}
